// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"f6b07fb6","394":"2006880b","483":"bcd5f46f","498":"9eae416e","571":"51502f7e"}[chunkId] + ".chunk.css";
};